export default "__VITE_ASSET__9c1bcadd__"